export const CONTACT_SECTION_TITLES = {
    contactCard: "Contact Card",
    customDescription: "Custom Description",
    information: "Information",
    customFields: "Custom Fields",
    organizations: "Organizations",
    quorumGenerated: "Quorum Generated",
}
